/**
 * Combat floating-text + small-beat feel — single knob file (constants
 * extraction, 2026-06-12).
 *
 * Consumed by CombatEventVFXHandler: the one-shot presentation beats that
 * ride combat modifier events (mana restore, interrupt, knockback, …).
 * FCT colors for damage/heal numbers live in the effect defs
 * (hit_physical/hit_heal/…), not here — these are only the hand-placed
 * texts and offsets the handler itself authors.
 */
export const COMBAT_TEXT_BEATS = {
  /** `combat:mana_restore` → "+N MP" text over the player. */
  manaRestore: { color: '#4488FF', fontSize: '12px', durationMs: 1000, offsetY: -30 },
  /** Cast-interrupt beat over the interrupted caster. */
  interrupted: { text: 'Interrupted!', color: '#FF4444', fontSize: '14px', durationMs: 1000, offsetY: -40 },
  /** `combat:knockback` → small directional burst scale. */
  knockbackBurstScale: 0.6,
  /** `combat:lifesteal` → heal number offset above the attacker. */
  lifestealOffsetY: -20,
  /** `combat:bonus_damage` → number offset beside the target. */
  bonusDamageOffset: { x: 15, y: -10 },
  /** `combat:status_tick` → tick-damage number offset. */
  statusTickOffsetY: -10,
  /** Source label under a DoT tick number ("Burn (tick)"). */
  tickLabel: { color: '#CCCCCC', fontSize: '11px', durationMs: 1000, extraOffsetY: 14 },
  /** Ability-name text offset above the caster. */
  abilityNameOffsetY: -30,
  /**
   * `combat:apply_effect` debuff routing defaults when the effect payload
   * omits them (StatusEffectManager.apply).
   */
  debuffDefaults: { durationMs: 3000, tickRateMs: 1000, maxStacks: 5 },
} as const;
